import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "react-router-dom";
import withCustomStyles from "./GSummary.style";

// Totals block. rows: [{ label, value, tone: "success" | undefined, strong }].
// Savings and free delivery are green; the total row is 18/800.
export const GSummary = withCustomStyles(({ classes, className, rows }) => (
  <dl className={classnames(classes.summary, className)}>
    {rows.filter(Boolean).map((row, i) => (
      <div
        key={row.key || i}
        className={classnames(classes.row, {
          [classes.total]: row.strong
        })}
      >
        <dt className={classes.label}>{row.label}</dt>
        <dd
          className={classnames(classes.value, {
            [classes.success]: row.tone === "success"
          })}
        >
          {row.value}
        </dd>
      </div>
    ))}
  </dl>
));

GSummary.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.node,
      tone: PropTypes.oneOf(["success"]),
      strong: PropTypes.bool
    })
  ).isRequired
};

const Chevron = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m9 6 6 6-6 6" />
  </svg>
);

// Navigational row: icon disc + two lines + chevron. Link, button or static.
export const GRow = withCustomStyles(
  ({ classes, className, icon, title, subtitle, to, href, onClick, aside }) => {
    const inner = (
      <>
        {icon && (
          <span className={classes.disc} aria-hidden="true">
            {icon}
          </span>
        )}
        <span className={classes.rowBody}>
          <span className={classes.rowTitle}>{title}</span>
          {subtitle && <span className={classes.rowSub}>{subtitle}</span>}
        </span>
        {aside}
        {(to || href || onClick) && (
          <span className={classes.chevron}>
            <Chevron />
          </span>
        )}
      </>
    );
    const cls = classnames(classes.navRow, className, {
      [classes.interactive]: to || href || onClick
    });
    if (to) {
      return (
        <Link to={to} className={cls} onClick={onClick}>
          {inner}
        </Link>
      );
    }
    if (href) {
      return (
        <a href={href} className={cls} onClick={onClick}>
          {inner}
        </a>
      );
    }
    if (onClick) {
      return (
        <button type="button" className={cls} onClick={onClick}>
          {inner}
        </button>
      );
    }
    return <div className={cls}>{inner}</div>;
  }
);

GRow.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  aside: PropTypes.node
};

export default GSummary;
